export default (value) => {
    return value;
}